import persistStore from 'redux-persist/lib/persistStore';

import store from './store';

/**
 * Reduxストアの永続化を管理するpersistor。
 *
 * store.ts側でpersistStore(store)を呼ぶと、`@/states/store`をimportするだけで
 * localStorageへの実際のrehydrate処理が走ってしまう(型やaction定義だけを使いたい
 * テスト等にも副作用が及ぶ)ため、専用モジュールに分離している。
 *
 * モジュールはプロセス内でキャッシュされるため、複数箇所からimportしても
 * persistStore()が複数回呼ばれることはなく、アプリ全体で同一のpersistorを共有する。
 */
export const persistor = persistStore(store);
